/**
 * Utility functions for handling dates in the application
 */

/**
 * Parse a date string from the database (YYYY-MM-DD) into a Date object
 */
export function parseDate(dateStr: string | null): Date | null {
  if (!dateStr) return null;
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day);
}

/**
 * Format a date for display using the browser's locale
 */
export function formatDisplayDate(date: Date | string | null): string {
  if (!date) return '';
  const dateObj = typeof date === 'string' ? parseDate(date) : date;
  if (!dateObj) return '';
  return dateObj.toLocaleDateString();
}

/**
 * Format a date for the HTML date input (YYYY-MM-DD)
 */
export function formatInputDate(date: string | null): string {
  if (!date) return '';
  const dateObj = parseDate(date);
  if (!dateObj) return '';
  return dateObj.toISOString().split('T')[0];
}

/**
 * Calculate days until a future date
 */
export function getDaysUntil(dateStr: string): number {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const targetDate = parseDate(dateStr);
  if (!targetDate) return 0;
  const diffTime = targetDate.getTime() - today.getTime();
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

/**
 * Format a date for database storage (YYYY-MM-DD)
 */
export function formatDatabaseDate(date: string | null): string | null {
  if (!date) return null;
  return date.split('T')[0]; // Remove any time component
} 